import { render, staticRenderFns } from "./EditExpence.vue?vue&type=template&id=45d25abe&"
import script from "./EditExpence.vue?vue&type=script&lang=js&"
export * from "./EditExpence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports